import { Card } from "@/components/ui/card";
import { MessageSquare } from "lucide-react";

interface ChatMessage {
  username: string;
  message: string;
  timestamp: string;
}

const ExampleChatSnippets = () => {
  const mockConversations: ChatMessage[][] = [
    [
      { username: "TechEnthusiast42", message: "Just finished reading that article on sustainable tech. Really makes you think about our daily choices.", timestamp: "2m ago" },
      { username: "GreenThinking", message: "Absolutely! I've started looking into solar panels for my home. The initial cost is steep though.", timestamp: "1m ago" },
      { username: "DataDriven", message: "Check out the government incentives. They can reduce the cost by 30-40% in some areas.", timestamp: "30s ago" },
    ],
    [
      { username: "BookwormSam", message: "Anyone else reading 'The Midnight Library'? I can't put it down!", timestamp: "5m ago" },
      { username: "ReadingCorner", message: "Finished it last week! The concept is so thought-provoking. Won't spoil anything.", timestamp: "3m ago" },
      { username: "PageTurner", message: "Added to my list. You all always have the best recommendations.", timestamp: "1m ago" },
    ],
    [
      { username: "CoffeeAddict", message: "Finally perfected my cold brew recipe after 2 months of experimenting.", timestamp: "10m ago" },
      { username: "BeanCounter", message: "Share the recipe! I've been trying to get mine right for weeks.", timestamp: "8m ago" },
      { username: "CoffeeAddict", message: "Key is the grind size and brew time. Coarse grind, 18-24 hours in fridge.", timestamp: "6m ago" },
    ],
  ];

  return (
    <div className="space-y-4">
      <div className="text-center space-y-2 mb-8">
        <h2 className="text-3xl font-bold">Real Conversations Happening Now</h2>
        <p className="text-muted-foreground">
          Join live discussions with real people about topics that matter
        </p>
      </div>
      
      <div className="grid md:grid-cols-3 gap-6">
        {mockConversations.map((conversation, idx) => (
          <Card key={idx} className="p-4 space-y-3 hover:border-primary transition-colors">
            <div className="flex items-center gap-2 text-primary font-semibold text-sm">
              <MessageSquare className="w-4 h-4" />
              <span>Live Chat Preview</span>
            </div>
            <div className="space-y-3">
              {conversation.map((msg, msgIdx) => (
                <div key={msgIdx} className="space-y-1">
                  <div className="flex items-center gap-2 text-xs">
                    <span className="font-medium text-foreground">{msg.username}</span>
                    <span className="text-muted-foreground">{msg.timestamp}</span>
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {msg.message}
                  </p>
                </div>
              ))}
            </div>
            <div className="pt-2 border-t border-border text-xs text-muted-foreground text-center">
              Premium members only
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ExampleChatSnippets;
